/* Aklasu Tie Pairing Tool. Generated from the CDO prototype; do not hand-edit here.
   Source of truth: CDO/tie-pairing-tool/tie-guide.html + batch/cdn-manifest.json */
(function(){
var ROOT=document.getElementById('ak-tie-pairing');
if(!ROOT)return;
var LOOKMAP={}, LOOKS=new Set();
var BLOCKS={};
try{
  var bt=ROOT.querySelector('[data-ak-blocks]');
  if(bt)BLOCKS=JSON.parse(bt.textContent)||{};
}catch(e){BLOCKS={};}
function blockCopy(colour){var b=BLOCKS[colour];return b&&b.body?b.body:null;}
// 2026-10-10: the pairing blocks are written per tie and name the suits they
// suit, so on the answer screen they only show when the visitor's suit or jacket
// is one of those. Navy tie on a navy suit (light blue shirt) was showing copy
// about grey and charcoal. SUIT_TIE_COPY carries suit-specific lines that win
// over the block; a result with neither shows the pattern verdict alone.
var SUIT_TIE_COPY={
  'black|navy':'Navy keeps a black suit from looking severe. It is dark enough to belong beside the black, and the open weave of the grenadine keeps its depth where a flat silk would go dead.',
  'brown|burgundy':'Burgundy and brown share the same warmth, so the pairing holds together by temperature rather than contrast. Against a pink shirt it carries the red through the outfit without repeating it.',
  'navy|navy':'Navy on navy is a tonal pairing: one colour at two depths, with the light blue shirt setting them apart. The grenadine\'s open weave gives the tie a texture the suit cloth lacks, so the two stay distinct.'
};
// Suit-specific note for the second-colour alternate, where the generic line
// would be wrong. Black on black is not 'less expected', it is the evening answer.
var ALT_NOTE={
  'black|black':'Black on black, for the evening. The tie shows through its weave rather than its colour.'
};
// A bow tie is not part of the tie line, so it lives here rather than in the
// products JSON, where productBy would pick it up as a black solid tie.
// Shown only on a black suit with a plain white shirt.
var EVENING_BOW={id:'black-batwing-bow-tie',title:'Black Batwing Bow-Tie',price:'$75',url:'/products/black-batwing-bow-tie',img:'https://cdn.shopify.com/s/files/1/1175/5540/files/ak-tp-tie-black-batwing-bow-tie.jpg'};
var EVENING_NOTE='For a black tie optional evening. A self-tie silk batwing, slimmer than a butterfly bow, worn with the same white shirt.';
function answerCopy(colour,upper,isSuit){
  var own=isSuit?SUIT_TIE_COPY[upper+'|'+colour]:null;if(own)return own;
  var b=BLOCKS[colour];if(!b||!b.body)return null;
  var listed=String(b.suits||'').toLowerCase().split(',').map(function(x){return x.trim();});
  return listed.indexOf(String(upper).toLowerCase())>-1?b.body:null;
}
function LOOKURL(k){return LOOKMAP[k]||null;}

// ---------- the line ----------
// PRODUCTS is loaded from assets/ak-tie-pairing-products.json, which classifies
// every active tie by colour, pattern, weave and marker. Editing that file is how
// the line is kept current: nothing here needs touching when a tie is added.
// The short list below is only a fallback for a failed fetch, so the tool still
// answers rather than showing a recommendation with nothing attached to it.
var PRODUCTS=[];
const CDN='https://cdn.shopify.com/s/files/1/1175/5540/files/';
const PRODUCTS_FALLBACK=[
  {id:'navy-grenadine',color:'navy',pattern:'solid',title:'Navy Grenadine Tie',price:'$105',tier:'Foundational',url:'/products/navy-grenadine-tie',img:CDN+'ak-tp-tie-navy.jpg'},
  {id:'burgundy-grenadine',color:'burgundy',pattern:'solid',title:'Burgundy Grenadine Tie',price:'$105',tier:'Foundational',url:'/products/burgundy-grenadine-tie',img:CDN+'ak-tp-tie-burgundy.jpg'},
  {id:'black-grenadine',color:'black',pattern:'solid',title:'Black Grenadine Tie',price:'$105',tier:'Foundational',url:'/products/black-grenadine-tie',img:CDN+'ak-tp-tie-black.jpg'},
  {id:'charcoal-grenadine',color:'grey',pattern:'solid',title:'Charcoal Grenadine Tie',price:'$105',tier:'Refined',url:'/products/charcoal-grenadine-tie',img:CDN+'ak-tp-tie-charcoal.jpg'},
  {id:'brown-grenadine',color:'brown',pattern:'solid',title:'Brown Grenadine Tie',price:'$105',tier:'Refined',url:'/products/brown-grenadine-tie',img:CDN+'ak-tp-tie-brown.jpg'},
  {id:'forest-green-grenadine',color:'green',pattern:'solid',title:'Forest Green Grenadine Tie',price:'$105',tier:'Refined',url:'/products/forest-green-grenadine-tie',img:CDN+'ak-tp-tie-green.jpg'},
  {id:'purple-grenadine',color:'purple',pattern:'solid',title:'Purple Grenadine Tie',price:'$105',tier:'Refined',url:'/products/purple-grenadine-tie',img:CDN+'ak-tp-tie-purple.jpg'},
  {id:'burnt-orange-grenadine',color:'orange',pattern:'solid',title:'Burnt Orange Grenadine Tie',price:'$105',tier:'Refined',url:'/products/burnt-orange-grenadine-tie',img:CDN+'ak-tp-tie-orange.jpg'},
  {id:'honey-brown-grenadine',color:'honey',pattern:'solid',title:'Honey Brown Grossa Grenadine',price:'$110',tier:'Refined',url:'/products/honey-brown-grossa-grenadine',img:CDN+'ak-tp-tie-honey.jpg'},
  {id:'champagne-grenadine',color:'champagne',pattern:'solid',title:'Champagne Grenadine',price:'$105',tier:'Refined',url:'/products/champagne-grenadine-tie',img:CDN+'ak-tp-tie-champagne.jpg'},
  {id:'midnight-grenadine',color:'midnight',pattern:'solid',title:'Midnight Blue Grossa Grenadine',price:'$110',tier:'Refined',url:'/products/midnight-blue-grossa-grenadine',img:CDN+'ak-tp-tie-midnight.jpg'},
  {id:'intro-stripe',color:'navy',pattern:'stripe',title:'"Intro" Navy & Steel Blue Block Stripe',price:'$110',tier:'Seasonal',url:'/products/intro-navy-and-steel-blue-block-striped-grenadine-tie',img:CDN+'ak-tp-tie-intro-stripe.jpg'}
];
// The fallback rows use `color`; the manifest uses `colour`. Normalise on read so
// the rest of the file only ever sees one spelling.
function normaliseProducts(list){
  return (list||[]).map(function(p){
    return {id:p.id,title:p.title,url:p.url,price:p.price,img:p.img,
      colour:p.colour||p.color,colour2:p.colour2||null,
      pattern:p.pattern||'solid',weave:p.weave||'Grenadine',marker:p.marker||p.tier||''};
  });
}
PRODUCTS=normaliseProducts(PRODUCTS_FALLBACK);
const productBy=(colour,pattern)=>PRODUCTS.find(p=>p.colour===colour&&p.pattern===pattern);
const productsIn=(colour)=>PRODUCTS.filter(p=>p.colour===colour||p.colour2===colour);



const PATLABEL_={solid:'solid',stripe:'striped',check:'checked',dot:'dotted',motif:'motif'};
const SHIRTLAB_={white:'white',lightblue:'light blue',pink:'pink'};
// Find the closest photographed look. Anything we could not shoot is carried by copy instead:
// the photo shows the nearest resolved outfit, and the note names exactly what differs.
function resolveLook(pt){
  const tie=pt.tie, cands=[]; let diffs=[];
  const pushSuit=(u,up,sc,sp)=>cands.push(`${u}-${up}_${sc}-${sp}_${tie}-solid`);
  const pushSep =(j,jp,tr,sc,sp)=>cands.push(`${j}-${jp}-jkt_${tr}-trs_${sc}-${sp}_${tie}-solid`);
  if(pt.sep){
    pushSep(pt.upper,pt.upperPat,pt.trouser,pt.shirt,pt.shirtPat);
    // keep the JACKET's pattern before giving it up: cloth pattern reads far louder
    // than shirt colour, so substitute the shirt first.
    pushSep(pt.upper,pt.upperPat,pt.trouser,pt.shirt,'solid');
    pushSep(pt.upper,pt.upperPat,pt.trouser,'white','solid');
    pushSep(pt.upper,pt.upperPat,pt.trouser,'lightblue','solid');
    pushSep(pt.upper,'solid',pt.trouser,pt.shirt,'solid');
    pushSep(pt.upper,'solid',pt.trouser,'white','solid');
    pushSep(pt.upper,'solid',pt.trouser,'lightblue','solid');
    ['grey','charcoal','navy','tan'].forEach(tr=>{
      pushSep(pt.upper,'solid',tr,'white','solid');
      pushSep(pt.upper,'solid',tr,'lightblue','solid');});
    // last resort: the matching-suit photo in the jacket's colour family. The jacket reads
    // differently, but the tie is the answer and the tie stays correct.
    const fam=(JACKETS[pt.upper]||{}).key||pt.upper;
    pushSuit(fam,'solid',pt.shirt,'solid');
    pushSuit(fam,'solid','white','solid');
    pushSuit(fam,'solid','lightblue','solid');
  }else{
    pushSuit(pt.upper,pt.upperPat,pt.shirt,pt.shirtPat);
    // same principle: hold the SUIT's pattern, swap the shirt, before falling back to solid cloth
    pushSuit(pt.upper,pt.upperPat,pt.shirt,'solid');
    pushSuit(pt.upper,pt.upperPat,'white','solid');
    pushSuit(pt.upper,pt.upperPat,'lightblue','solid');
    pushSuit(pt.upper,'solid',pt.shirt,'solid');
    pushSuit(pt.upper,'solid','white','solid');
    pushSuit(pt.upper,'solid','lightblue','solid');
  }
  const hit=cands.find(k=>LOOKS.has(k));
  if(!hit)return{src:null,key:cands[0],note:null};
  const tieDiff=pt.tiePat&&pt.tiePat!=='solid';
  if(hit===cands[0]&&!tieDiff)return{src:LOOKURL(hit),key:hit,note:null};
  // say plainly what the photograph does not show. the copy carries what we could not shoot.
  var shownPat=pt.sep?(hit.match(/^[a-z]+-([a-z]+)-jkt_/)||[])[1]:(hit.match(/^[a-z]+-([a-z]+)_/)||[])[1];
  if(pt.upperPat!=='solid'&&shownPat==='solid')diffs.push(`in solid cloth rather than your ${PATLABEL_[pt.upperPat]} ${pt.sep?'jacket':'suit'}`);
  const shownShirt=hit.split('_').slice(-2)[0].split('-')[0];
  const shirtColDiff=shownShirt!==pt.shirt, shirtPatDiff=pt.shirtPat!=='solid';
  if(shirtColDiff&&shirtPatDiff)diffs.push(`with a plain ${SHIRTLAB_[shownShirt]} shirt rather than your ${SHIRTLAB_[pt.shirt]} ${PATLABEL_[pt.shirtPat]} one`);
  else if(shirtPatDiff)diffs.push(`with a plain shirt rather than your ${PATLABEL_[pt.shirtPat]} one`);
  else if(shirtColDiff)diffs.push(`with a ${SHIRTLAB_[shownShirt]} shirt rather than ${SHIRTLAB_[pt.shirt]}`);
  if(tieDiff)diffs.push(`with a solid tie rather than your ${PATLABEL_[pt.tiePat]} one`);
  const shownTrs=pt.sep?(hit.match(/_([a-z]+)-trs_/)||[])[1]:null;
  if(pt.sep&&!hit.includes('-jkt_'))diffs.push('as a matching suit rather than your jacket and trousers');
  else if(shownTrs&&shownTrs!==pt.trouser)diffs.push(`over ${shownTrs} trousers rather than ${pt.trouser}`);
  let note=null;
  if(diffs.length>=3){
    const structural=diffs.filter(d=>d.startsWith('as a matching suit')||d.startsWith('over ')||d.startsWith('with a solid tie'));
    diffs=structural.concat(['in plain cloth']);
  }
  if(diffs.length){
    const anyPat=pt.upperPat!=='solid'||shirtPatDiff;
    note='Shown '+diffs.join(', ')+'. '
       +(tieDiff?'The colour and its relationship to the outfit are what matter here.'
                :'The tie does not change. '+(anyPat?'Pattern already in the outfit only strengthens the case for a solid one.'
                                                    :'Your colours sit in the same relationship to it.'));
  }
  return{src:LOOKURL(hit),key:hit,note};
}

// ---------- affinity (extends prototype with black) ----------
// Affinity is a STYLE judgement. It must never be tuned to inventory:
// if the right answer is out of stock, the right answer is still shown.
const COLOR_SCORE={
  // 2026-09-26, founder ruling: navy is the tried-and-true base, and it should
  // also carry the less expected answers. Burnt orange and honey brown rise to be
  // the natural alternates, and black clears the 0.70 floor so a black tie is
  // shown against navy on the tie path.
  navy:{burgundy:0.95,navy:0.9,orange:0.88,honey:0.86,brown:0.85,green:0.85,champagne:0.82,purple:0.75,black:0.72,olive:0.72,red:0.72,grey:0.7,gold:0.7,pink:0.68,teal:0.66,paleblue:0.62,lavender:0.6,tan:0.55,midnight:0.45},
  // 2026-09-25: navy leads on charcoal (founder ruling, the business classic).
  charcoal:{navy:0.95,burgundy:0.9,midnight:0.85,green:0.8,black:0.8,champagne:0.8,purple:0.78,gold:0.72,red:0.72,pink:0.66,grey:0.65,teal:0.64,lavender:0.62,olive:0.62,brown:0.6,paleblue:0.6,honey:0.55,orange:0.5,tan:0.45},
  grey:{navy:0.95,burgundy:0.9,green:0.85,purple:0.85,brown:0.8,olive:0.8,orange:0.78,gold:0.76,honey:0.75,midnight:0.75,red:0.75,pink:0.74,champagne:0.72,teal:0.72,lavender:0.7,paleblue:0.68,black:0.55,tan:0.55,grey:0.4},
  // Black is deliberately the narrowest row in the table. Founder ruling: with a
  // black suit the range is dark colours and subtle pattern, and burgundy is not
  // recommended at all. Only these four clear the 0.70 floor, which is the point.
  // See the journal piece on the navy tie with a black suit: against black the
  // weave carries the interest, not the colour, so a flat bright silk has nothing
  // to offer and an open grenadine in a dark colour has everything.
  black:{navy:0.95,black:0.92,midnight:0.90,grey:0.85,champagne:0.55,purple:0.5,burgundy:0.5,red:0.45,green:0.45,gold:0.4,pink:0.35,lavender:0.35,teal:0.35,paleblue:0.3,olive:0.3,brown:0.25,honey:0.25,orange:0.2,tan:0.2},
  brown:{green:0.9,burgundy:0.85,orange:0.85,olive:0.85,honey:0.82,gold:0.8,navy:0.8,champagne:0.7,brown:0.65,paleblue:0.62,teal:0.62,red:0.6,pink:0.55,purple:0.5,grey:0.4,lavender:0.4,midnight:0.35,tan:0.35,black:0.2}
};
const SUITS={navy:'#232c40',charcoal:'#33353a',grey:'#9a9da3',black:'#17171a',brown:'#54422f'};
// Tie colours that read as the same hue family as the suit. Fine as the main
// recommendation, where a tonal answer is often the most polished thing a man can
// do; wrong as the alternate, which is there to offer a different idea.
const SUIT_HUE={
  navy:['navy','midnight','paleblue','teal'],
  charcoal:['grey','black','midnight'],
  grey:['grey','black'],
  // 2026-10-10: black removed so the black grenadine can be the alternate on a
  // black suit (founder call). Black on black is a real option for evening.
  black:['grey','midnight'],
  brown:['brown','honey','tan','champagne']
};
const SHIRTS={white:'#fdfdfc',lightblue:'#c9d9e8',pink:'#ecd4d4'};
const COLLABEL={navy:'navy',burgundy:'burgundy',brown:'brown',green:'forest green',grey:'charcoal',black:'black',purple:'purple',orange:'burnt orange',honey:'honey brown',champagne:'champagne',midnight:'midnight blue',olive:'olive',gold:'gold',pink:'dusty rose',paleblue:'pale blue',lavender:'lavender',teal:'teal',red:'red',tan:'tan'};
// "an olive tie", not "a olive tie"
const article=w=>/^[aeiou]/i.test(w||'')?'an':'a';
const SHOE={navy:'brown',charcoal:'black',grey:'brown',black:'black',brown:'brown'};
const JACKETS={navy:{hex:'#232c40',L:2,hue:'blue',key:'navy'},blue:{hex:'#3f5d80',L:5,hue:'blue',key:'navy'},charcoal:{hex:'#33353a',L:2,hue:'grey',key:'charcoal'},grey:{hex:'#8a8d93',L:5,hue:'grey',key:'grey'},tan:{hex:'#b79b6e',L:7,hue:'earth',key:'brown'},brown:{hex:'#5b4630',L:3,hue:'earth',key:'brown'},olive:{hex:'#5c5a34',L:4,hue:'green',key:'brown'}};
const JLABEL={navy:'Navy',blue:'Blue',charcoal:'Charcoal',grey:'Grey',tan:'Tan',brown:'Brown',olive:'Olive'};
const TROUSERS={charcoal:{hex:'#33353a',L:2,hue:'grey',vers:3},grey:{hex:'#8a8d93',L:5,hue:'grey',vers:3},navy:{hex:'#232c40',L:2,hue:'blue',vers:2},tan:{hex:'#b79b6e',L:7,hue:'earth',vers:2},cream:{hex:'#d9cdb3',L:9,hue:'earth',vers:1}};
const TLABEL={charcoal:'Charcoal',grey:'Grey',navy:'Navy',tan:'Tan',cream:'Cream'};
const TROUSER_NOTE={grey:'The universal anchor: clean contrast under almost any jacket.',charcoal:'A deeper grey base; versatile and a touch dressier.',navy:'Sharp and versatile; keep the jacket clearly apart from it.',tan:'A warm, lighter base; natural under blues and greens.',cream:'A pale summer base; wants a jacket with real depth above it.'};
function trouserRec(jc){
  const j=JACKETS[jc];
  let arr=Object.entries(TROUSERS).map(([id,t])=>{const sameHue=t.hue===j.hue,contrast=Math.abs(j.L-t.L);const disq=sameHue&&contrast<4;const score=t.vers*2+Math.min(contrast,5)*0.6-(sameHue?2.5:0);return{id,label:TLABEL[id],hex:t.hex,score,disq};}).filter(x=>!x.disq).sort((a,b)=>b.score-a.score).slice(0,3);
  arr.forEach((x,i)=>{x.top=i===0;let note=TROUSER_NOTE[x.id];if(i===0){if(j.L>=6)note+=' Your jacket is the lighter piece, so this darker base grounds it.';else if(j.L<=3)note+=' A lighter base here keeps the look from passing for a matching suit.';}x.note=note;});
  return arr;
}

// principle text (guide voice, from prototype)
function ruleFor(sp,shp){
  const suitPat=sp!=='solid',shirtPat=shp!=='solid';
  if(!suitPat&&!shirtPat)return{title:'Clean, sophisticated, timeless.',body:"This combination does not take much effort, and it is at home at the office, a banquet hall or a Michelin-starred restaurant. A solid or a subtle pattern will both work; for the most polished result, let the tie be an understated solid."};
  if(!suitPat&&shirtPat)return{title:'Let the tie be the calm.',body:"Your shirt already carries a pattern, so a solid-coloured tie is the safest, most polished choice. A patterned tie can work only if its design is completely different from the shirt. The easier your outfit is to take in, the more considered it looks."};
  if(suitPat&&!shirtPat)return{title:'Depth, without clutter.',body:"A patterned suit over a solid shirt is a refined way to wear pattern. A solid tie works beautifully here. If you go patterned, make sure it is clearly discernible from the suit: a different scale, a different idea."};
  return{title:'Three patterns: tread carefully.',body:"Pattern on the suit, shirt and tie can get busy fast. Never repeat the same pattern, keep each one clearly distinguishable, and be careful with colour. When in doubt, let the tie be the solid that settles it."};
}
// derive the ideal-tie guidance for a situation
function guidance(st){
  const{suitColor,suitPattern,shirtColor,shirtPattern,jacket}=st;
  const scores={...COLOR_SCORE[suitColor]};
  const bump=(c,n)=>{scores[c]=(scores[c]||0)+n;};
  // The shirt is a third of what a man is wearing and it should move the answer.
  // A light blue shirt is a cool field, so a warm tie reads as a decision rather
  // than a default. Pink pushes the other way, toward the red and purple family,
  // and away from green, which turns muddy against it.
  if(shirtColor==='lightblue'){
    // 2026-09-25: 0.04 -> 0.08 so navy suit, light blue shirt, navy tie wins.
    bump('navy',0.08);
    ['brown','honey','champagne','olive','orange','gold'].forEach(c=>bump(c,0.06));
  }
  if(shirtColor==='pink'){
    bump('burgundy',0.05);bump('purple',0.05);bump('lavender',0.04);bump('midnight',0.03);
    bump('green',-0.1);bump('orange',-0.05);
  }
  // Busy cloth wants a quieter, deeper tie. Light warm colours fight a stripe or
  // a check rather than settling it.
  if(suitPattern!=='solid'){
    ['burgundy','navy','midnight','green','purple','black'].forEach(c=>bump(c,0.03));
    ['champagne','honey','gold','orange','paleblue','pink'].forEach(c=>bump(c,-0.06));
  }
  // 2026-09-25, founder ruling: grey suits bring in the warm browns. Grey is
  // light enough to show them properly. Honey brown becomes the alternate on a solid
  // grey suit, and burnt orange leads outright against a light blue shirt, a
  // warm tie on a cool field. The pattern and pink-shirt penalties above still
  // apply, so busy cloth keeps its deeper ties.
  // 2026-09-25, founder ruling: charcoal points to black. Against a white shirt
  // the black grenadine leads, a sharp tonal answer; light blue keeps navy and
  // pink keeps burgundy, so charcoal still spreads across three ties.
  if(suitColor==='charcoal'&&shirtColor==='white')bump('black',0.2);
  // 2026-09-26: a blue odd jacket is lighter than a navy suit, so a navy tie
  // reads as depth against it rather than a match. Navy leads there.
  if(jacket==='blue')bump('navy',0.1);
  if(suitColor==='grey'){
    bump('honey',0.16);
    if(shirtColor==='lightblue'&&suitPattern==='solid')bump('orange',0.2);
  }
  // rank colours that have a solid product
  const ranked=Object.entries(scores).sort((a,b)=>b[1]-a[1]);
  const colours=ranked.map(e=>e[0]).filter(c=>productBy(c,'solid'));
  const top=colours.slice(0,2);
  const rule=ruleFor(suitPattern,shirtPattern);
  const anySuitPat=suitPattern!=='solid',anyShirtPat=shirtPattern!=='solid';
  // pattern verdict, and which tie patterns the outfit can actually carry.
  // A patterned shirt closes the door on all of them: two patterns fighting at
  // the collar is the single most common way this goes wrong.
  let patternLine,allowedPatterns=[];
  if(!anySuitPat&&!anyShirtPat){patternLine='A solid is the most polished; a subtle pattern can work if nothing else is bold.';allowedPatterns=['stripe','dot','motif','check'];}
  else if(!anySuitPat&&anyShirtPat){patternLine='Keep it solid so it does not fight the shirt.';allowedPatterns=[];}
  else if(anySuitPat&&!anyShirtPat){
    patternLine='A solid looks cleanest; a clearly different pattern can add depth if you want it.';
    // Never the same pattern family as the suit. A striped tie on a striped suit
    // is the mistake the guidance warns about two paragraphs higher up, and a
    // difference of scale is not enough to rescue it.
    allowedPatterns=['stripe','dot','motif','check'].filter(k=>k!==suitPattern);
  }
  else{patternLine='With pattern already on the suit and shirt, let the tie be solid.';allowedPatterns=[];}

  const primary=productBy(top[0],'solid');

  // Alternate one: a patterned tie, only when the outfit can carry one, scored on
  // the same colour affinity. Never chosen to fill a slot; if nothing clears the
  // floor, the answer is simply the one tie.
  let altPattern=null;
  if(allowedPatterns.length){
    const cands=PRODUCTS
      .filter(p=>allowedPatterns.indexOf(p.pattern)>-1)
      .map(p=>({p,s:Math.max(scores[p.colour]||0,(scores[p.colour2]||0)-0.05)}))
      .filter(x=>x.s>=0.7)
      .sort((a,b)=>b.s-a.s);
    if(cands.length)altPattern=cands[0].p;
  }
  // Alternate two: the same argument in a second colour. It skips anything in the
  // suit's own hue family, because a navy tie under a navy suit is a tonal answer,
  // not a different idea, and this slot exists to show a different idea.
  let altColour=null;
  const sameHue=SUIT_HUE[suitColor]||[];
  for(let i=0;i<colours.length;i++){
    const c=colours[i];
    if(primary&&c===primary.colour)continue;
    if(sameHue.indexOf(c)>-1)continue;
    if(scores[c]<0.7)continue;
    const p=productBy(c,'solid');
    if(p&&(!primary||p.id!==primary.id)){altColour=p;break;}
  }
  const colourPhrase=top.map(c=>COLLABEL[c]).join(' or ');
  const typeSentence=`Reach for an understated solid, ${colourPhrase} sits most naturally here, in a matte grenadine weave, nothing shiny. ${patternLine}`;
  const shoe=SHOE[suitColor];
  const cap=`Full look. ${st.suitColor} ${suitPattern} suit, ${st.shirtColor} ${shirtPattern} shirt, finished with a ${COLLABEL[top[0]]} solid grenadine tie. ${shoe} shoes. One resolved outfit; no element more prominent than the rest.`;
  const key=`${suitColor}-${suitPattern}_${shirtColor}-${shirtPattern}_${top[0]}-solid`;
  return{rule,colours:top,typeSentence,primary,altPattern,altColour,anySuitPat,cap,key};
}
const PATTERN_ADVICE={solid:'A solid tie, so the suit and shirt can be solid or subtly patterned. Keep every element understated.',stripe:'A striped tie is business-first. Keep the suit and shirt solid, or a clearly different scale of stripe.',dot:'A dotted tie is subtly expressive. Wear it against solids, with the dots spaced enough to look clean.',motif:'A motif tie, foulard, paisley or floral, is the most expressive. Anchor it with a solid suit and shirt so it leads.'};
// how to wear a chosen tie (path B)
// Why THIS suit, rather than what the tie's pattern asks for. The pattern advice
// is the same for all three pairings by definition, so printing it three times
// read as filler in a tool whose whole claim is that it explains itself. It now
// sits once, in the intro, and each pairing says something true about the suit.
const SUIT_REASON={
  navy:'The most formal of the five and the least fussy. It takes almost any tie colour with ease, which is why it is the first suit most men own.',
  charcoal:"Navy's more understated cousin. It sits further back, so a tie with real depth of colour has room to be the only thing with a pulse.",
  grey:'The most generous base in tailoring. Light enough to show a colour properly, which is why it flatters ties that navy would swallow.',
  black:'Ordinary clothing, not costume, once the shirt stays white. The range narrows to dark colours and subtle pattern, and the weave matters more than the colour: a flat silk goes dead beside a dark suit where an open grenadine keeps its depth.',
  brown:'The warm base, and it pairs by temperature rather than contrast. Greens, rusts and golds belong here; cool colours sit apart from it.'
};
function combosFor(tie){
  const suitName={navy:'Navy suit',charcoal:'Charcoal suit',grey:'Grey suit',black:'Black suit',brown:'Brown suit'};
  const ranked=Object.entries(COLOR_SCORE).map(([suit,m])=>({suit,score:m[tie.color]??0}))
    .sort((a,b)=>b.score-a.score)
    .filter(r=>r.score>=0.70)   // quality floor: never show a weak pairing just to fill a third slot
    .slice(0,3);
  return ranked.map((r,i)=>{
    const shirt=i===1?'lightblue':'white';
    const cap=`Full look. ${r.suit} suit, ${shirt==='lightblue'?'light blue':'white'} shirt, worn with the ${tie.title}. ${SHOE[r.suit]} shoes.`;
    return{suit:r.suit,shirt,suitLabel:suitName[r.suit],shirtLabel:shirt==='lightblue'?'Light blue shirt':'White shirt',
      note:(i===0?'The foundation pairing. ':'')+SUIT_REASON[r.suit],top:i===0,cap};
  });
}
// ---------- dom helper ----------
// setAttribute used to run for every key regardless of value, so a null turned
// into the string "null": disabled:null disabled the button it was meant to
// leave alone, and a missing image would have set src="null" and requested it.
// Null, undefined and false now mean "do not set this attribute".
const el=(t,a={},k=[])=>{const n=document.createElement(t);for(const key in a){if(key==='style')n.style.cssText=a[key];else if(key==='class')n.className=a[key];else if(key.startsWith('on'))n.addEventListener(key.slice(2).toLowerCase(),a[key]);else if(a[key]!==null&&a[key]!==undefined&&a[key]!==false)n.setAttribute(key,a[key]);}(Array.isArray(k)?k:[k]).forEach(c=>{if(c==null)return;n.appendChild(typeof c==='string'?document.createTextNode(c):c);});return n;};

// Selector plates are real cloth, cropped from the same photographs the answer
// screen uses. PLATES maps a key such as suit-navy to a Files URL; it is fetched
// alongside the look manifest. If a plate is missing the caption still reads, so
// a failed fetch degrades to a text list rather than an empty grid.
var PLATES={};
function plateSrc(k){return PLATES[k]||null;}
// 2026-09-24: plates used to start loading only when their screen opened, so
// every question arrived as empty boxes for half a second. While a question is
// on screen, fetch the plates of the question(s) that can follow it.
const NEXT_PLATES={
  paths:['suit-','jacket-'],suitColour:['suitpat-'],suitPattern:['shirt-'],
  jacketColour:['jacketpat-'],jacketPattern:['trouser-'],trouser:['shirt-']
};
const PRELOADED=new Set();
function preloadNext(){
  (NEXT_PLATES[state.screen]||[]).forEach(function(pre){
    Object.keys(PLATES).forEach(function(k){
      if(k.indexOf(pre)!==0||PRELOADED.has(k))return;
      PRELOADED.add(k);const im=new Image();im.decoding='async';im.src=PLATES[k];
    });
  });
}

function plate(src,label,sel,pick,alt,note){
  const kids=[];
  kids.push(src?el('img',{src:src,alt:alt||label,decoding:'async'})
                :el('span',{class:'ak-tp__swatch'}));
  const cap=[label];
  if(note)cap.push(el('span',{class:'ak-tp__plate-note'},note));
  kids.push(el('figcaption',{},cap));
  return el('figure',{class:'ak-tp__plate',role:'radio','aria-checked':sel?'true':'false',tabindex:'0',
    onClick:pick,
    onKeydown:e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();pick();}}},kids);
}
function colourPlate(hex,label,sel,pick){
  return el('figure',{class:'ak-tp__plate',role:'radio','aria-checked':sel?'true':'false',tabindex:'0',
    onClick:pick,
    onKeydown:e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();pick();}}},
    [el('span',{class:'ak-tp__swatch',style:'background:'+hex}),el('figcaption',{},label)]);
}
// The group needs a name or a screen reader announces "radio group" and leaves
// the listener to guess what is being chosen. The question is already on screen,
// so point at it rather than repeating it.
function plateGrid(n,items,label){
  const g=el('div',{class:'ak-tp__plates ak-tp__plates--'+n,role:'radiogroup','aria-labelledby':QID});
  if(label)g.setAttribute('aria-label',label);
  items.forEach(x=>g.appendChild(x));
  return g;
}

// A word list, for the questions we have no photograph for. Shirt pattern and
// tie pattern were never shot, and inventing a CSS approximation of a cloth is
// exactly the swatch problem we removed.
function wordList(items){
  const g=el('div',{class:'ak-tp__words',role:'radiogroup','aria-labelledby':QID});
  items.forEach(o=>{
    g.appendChild(el('div',{class:'ak-tp__word',role:'radio','aria-checked':o.sel?'true':'false',tabindex:'0',
      onClick:o.pick,onKeydown:e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();o.pick();}}},[
      el('span',{},[el('span',{class:'ak-tp__word-h h3'},o.label),o.note?el('span',{class:'ak-tp__word-p'},o.note):null])
    ]));
  });
  return g;
}

function look(cap,key,pt){
  const r=pt?resolveLook(pt):{src:LOOKS.has(key)?LOOKURL(key):null,note:null};
  const wrap=el('div',{class:'ak-tp__col'});
  if(r.src)wrap.appendChild(el('img',{class:'ak-tp__hero',src:r.src,alt:cap,loading:'lazy',decoding:'async'}));
  else wrap.appendChild(el('span',{class:'ak-tp__hero'}));
  if(r.src&&r.note)wrap.appendChild(el('p',{class:'ak-tp__heronote'},r.note));
  return wrap;
}

// Vault and seasonal ties are eligible recommendations, so the card has to say
// what kind of thing it is. The marker is a label, never a filter.
function productCard(p,note,why,extraClass){
  const kids=[
    el('img',{src:p.img,alt:p.title,loading:'lazy',decoding:'async'}),
    el('span',{class:'ak-tp__card-t'},p.title),
    el('span',{class:'ak-tp__card-p'},p.price+(note?' · '+note:''))
  ];
  if(p.marker==='Vault'||p.marker==='Seasonal')kids.push(el('span',{class:'ak-tp__card-m'},p.marker));
  if(why)kids.push(el('span',{class:'ak-tp__card-why'},why));
  return el('a',{class:'ak-tp__card'+(extraClass?' '+extraClass:''),href:p.url},kids);
}

// ---------- state ----------
// One question per screen. Selecting a plate advances: with a single question
// on the screen there is nothing for a Next button to do except add a step.

// ---------- the close ----------
// The tool argues its case and then has to ask for something. What it can ask
// for depends on stock, and most of the line is out of stock at any moment, so
// there are two closes rather than one: buy it, or be told when it returns.
// Never a dead button, because the recommendation is never suppressed for
// being unavailable - style supersedes stock.
function cartAdd(variantId,btn){
  btn.disabled=true;
  var was=btn.textContent;
  btn.textContent='Adding…';
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:variantId,quantity:1}]})
  }).then(function(r){
    if(!r.ok)throw new Error('cart');
    btn.textContent='Added to bag';
    btn.classList.add('is-done');
    // Tell the theme so the header count updates without a reload.
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
  }).catch(function(){
    btn.disabled=false;
    btn.textContent=was;
    btn.insertAdjacentText('afterend','');
  });
}

function buyBlock(p){
  if(!p)return el('p',{class:'ak-tp__spec'},'We do not make this exact tie. The guidance above still holds.');
  // Three states, not two. "We have not loaded the stock data yet" is not the
  // same as "this is out of stock", and conflating them showed the notify form
  // on an in-stock tie to anyone who reached an answer before the fetch landed.
  var known=!!p.variants;
  var vs=p.variants||[];
  var inStock=vs.filter(function(v){return v.available;});

  // The packshot is a reference, not the hero. The full-look photograph is the
  // hero, and two large pictures of the same tie on one screen were competing.
  var head=el('div',{class:'ak-tp__tierow'},[
    el('a',{class:'ak-tp__pack',href:p.url},
      el('img',{src:p.img,alt:p.title,loading:'lazy',decoding:'async'})),
    el('div',{class:'ak-tp__tiemeta'},[
      el('a',{class:'ak-tp__tiename',href:p.url},p.title),
      el('p',{class:'ak-tp__tieprice'},p.price),
      ((known&&!inStock.length)?el('p',{class:'ak-tp__stock'},'Out of stock at the moment.'):null),
      el('a',{class:'ak-tp__viewlink',href:p.url},'View the tie')
    ])
  ]);
  var kids=[head];

  // Stock unknown: say nothing about it. The tie and the link are true either
  // way, and applyLive re-renders the moment the real answer arrives.
  if(!known)return el('div',{class:'ak-tp__buy'},kids);

  if(!vs.length||!inStock.length){
    // The shared back-in-stock form, the same one the product page renders.
    // Point it at this tie and reveal it; nothing else about it changes.
    var slot=el('div',{class:'ak-tp__bis'});
    kids.push(slot);
    setTimeout(function(){mountBis(slot,p);},0);
    return el('div',{class:'ak-tp__buy'},kids);
  }

  var chosen=inStock[0].id;
  if(vs.length>1){
    var group=el('div',{class:'ak-tp__lens',role:'radiogroup','aria-label':'Length'});
    vs.forEach(function(v){
      var b=el('button',{
        class:'ak-tp__len'+(v.id===chosen?' is-on':''),
        type:'button',role:'radio','aria-checked':v.id===chosen?'true':'false',
        disabled:v.available?null:'disabled'
      },v.title+(v.available?'':' · out of stock'));
      b.addEventListener('click',function(){
        if(!v.available)return;
        chosen=v.id;
        Array.prototype.forEach.call(group.children,function(c){
          c.classList.remove('is-on');c.setAttribute('aria-checked','false');
        });
        b.classList.add('is-on');b.setAttribute('aria-checked','true');
      });
      group.appendChild(b);
    });
    kids.push(group);
  }
  var cta=el('button',{class:'ak-tp__cta',type:'button'},'Add to bag');
  cta.addEventListener('click',function(){cartAdd(chosen,cta);});
  kids.push(cta);
  return el('div',{class:'ak-tp__buy'},kids);
}

// The product page renders one hidden copy of the back-in-stock form. Rather
// than building a second, move that one into the tool's slot and retarget it.
// If the page has no copy (the tool can be placed on a page without a product
// form), fall through to a link so the visitor is never left with nothing.
// Where the shared form lives when it is not in an answer. render() empties the
// app on every screen change, so a form moved inside would be destroyed after a
// single use and every later out-of-stock answer would silently fall back to a
// link. It is parked outside the app and borrowed, never owned.
var BIS_HOME=null;
function bisPark(){
  var box=document.querySelector('[data-ak-bis]');
  if(box&&BIS_HOME&&box.parentNode!==BIS_HOME){
    box.hidden=true;
    BIS_HOME.appendChild(box);
  }
}
function mountBis(slot,p){
  var src=document.querySelector('[data-ak-bis]');
  if(src&&!BIS_HOME)BIS_HOME=src.parentNode;
  if(src&&!slot.contains(src)){
    slot.appendChild(src);
    src.hidden=false;
    src.setAttribute('data-variant-id',(p.variants&&p.variants[0]&&p.variants[0].id)||'');
    src.setAttribute('data-product-title',p.title||'');
    // Collapse it between answers so it never reopens already expanded.
    var panel=src.querySelector('[data-ak-bis-panel]');
    var tog=src.querySelector('[data-ak-bis-toggle]');
    var icon=src.querySelector('.ak-bis__toggle-icon');
    var form=src.querySelector('[data-ak-bis-form]');
    var ok=src.querySelector('[data-ak-bis-success]');
    if(panel)panel.hidden=true;
    if(tog)tog.setAttribute('aria-expanded','false');
    if(icon)icon.textContent='+';
    if(form)form.style.display='';
    if(ok)ok.classList.remove('is-visible');
    return;
  }
  if(!slot.firstChild)slot.appendChild(el('a',{class:'ak-tp__viewlink',href:p.url},"Notify me when it's back"));
}

// A man rarely buys a tie the moment he is told which one. The answer therefore
// has to survive leaving the page: every answer gets its own address.
function stateQuery(){
  var q;
  if(state.screen==='tieAnswer')q={w:'tie',t:state.tieColor+'-'+state.tiePattern};
  else if(state.mode==='separates')q={w:'sep',j:state.jacketColor+'-'+state.jacketPattern,
    r:state.trouserColor,s:state.shirtColor+'-'+state.shirtPattern};
  else q={w:'suit',u:state.suitColor+'-'+state.suitPattern,s:state.shirtColor+'-'+state.shirtPattern};
  return Object.keys(q).map(function(k){return k+'='+encodeURIComponent(q[k]);}).join('&');
}
// Keep ?view= when the tool runs as an alternate template of another page
// (e.g. /pages/first-tie-guide?view=tie-pairing). Without it, a shared or
// refreshed answer opened the host page instead of the tool. 2026-09-29.
function viewParam(){
  var m=/[?&]view=([^&#]*)/.exec(location.search);
  return m?'view='+m[1]:'';
}
function basePath(){
  var v=viewParam();
  return location.pathname+(v?'?'+v:'');
}
function withView(q){
  var v=viewParam();
  return '?'+(v?v+'&':'')+q;
}
function shareUrl(){
  return location.origin+location.pathname+withView(stateQuery());
}
function restoreFromQuery(){
  var ok=restoreFromQuery_();
  if(ok)['suitColor','suitPattern','jacketColor','jacketPattern','trouserColor','shirtColor','shirtPattern','tieColor','tiePattern'].forEach(function(k){ANSWERED.add(k);});
  // A shared link lands on the answer; Back should walk back through the
  // questions that produced it, not jump to the start screen.
  if(ok){
    var f=state.screen==='tieAnswer'?['tieColour','tiePattern']:(state.mode==='separates'?['jacketColour','jacketPattern','trouser','shirtColour','shirtPattern']:['suitColour','suitPattern','shirtColour','shirtPattern']);
    HISTORY.length=0;HISTORY.push.apply(HISTORY,['start','paths'].concat(f));
  }
  return ok;
}
function restoreFromQuery_(){
  var q={};
  location.search.replace(/^\?/,'').split('&').forEach(function(kv){
    if(!kv)return;var i=kv.indexOf('=');
    q[kv.slice(0,i)]=decodeURIComponent(kv.slice(i+1));
  });
  var two=function(v,a,b){var x=String(v||'').split('-');return x.length>1?[x[0],x[1]]:[x[0],b];};
  if(q.w==='tie'&&q.t){
    var t=two(q.t);state.tieColor=t[0];state.tiePattern=t[1]||'solid';
    state.screen='tieAnswer';return true;
  }
  if(q.w==='suit'&&q.u&&q.s){
    var u=two(q.u),sh=two(q.s);
    state.mode='suit';state.suitColor=u[0];state.suitPattern=u[1]||'solid';
    state.shirtColor=sh[0];state.shirtPattern=sh[1]||'solid';
    state.screen='answer';return true;
  }
  if(q.w==='sep'&&q.j&&q.s){
    var j=two(q.j),sh2=two(q.s);
    state.mode='separates';state.jacketColor=j[0];state.jacketPattern=j[1]||'solid';
    if(q.r)state.trouserColor=q.r;
    state.shirtColor=sh2[0];state.shirtPattern=sh2[1]||'solid';
    state.screen='answer';return true;
  }
  return false;
}
// The two things you can do with an answer besides buy it. Neither is the
// action the page is asking for, so neither is a button with a fill.
// 2026-09-24 founder markup: "Copy link to this look" became a share icon on
// the right; "Start again" moved left beside Back.
var SHARE_SVG='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3v12"/><path d="M7.5 7.5 12 3l4.5 4.5"/><path d="M5 11v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8"/></svg>';
function shareLink(){
  var btn=el('button',{class:'ak-tp__barlink ak-tp__share',type:'button','aria-label':'Share this look',title:'Share this look'});
  btn.innerHTML=SHARE_SVG;
  var msg=el('span',{class:'ak-tp__sharemsg','aria-live':'polite'});
  btn.addEventListener('click',function(){
    var u=shareUrl();
    // Phones get the native share sheet; everything else copies the link.
    if(navigator.share&&matchMedia('(pointer: coarse)').matches){
      navigator.share({title:document.title,url:u}).catch(function(){});
      return;
    }
    var done=function(){
      msg.textContent='Link copied';
      setTimeout(function(){msg.textContent='';},1800);
    };
    if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(u).then(done,done);
    else{try{prompt('Copy this link',u);}catch(e){}}
  });
  return el('span',{class:'ak-tp__sharewrap'},[msg,btn]);
}
function startAgainLink(){
  var again=el('button',{class:'ak-tp__barlink',type:'button'},'Start again');
  again.addEventListener('click',function(){
    HISTORY.length=0;
    ANSWERED.clear();
    try{history.replaceState(null,'',basePath());}catch(e){}
    go('start');
  });
  return again;
}


const state={screen:'start',mode:'suit',suitColor:'navy',suitPattern:'solid',shirtColor:'white',shirtPattern:'solid',tieId:null,tieColor:'navy',tiePattern:'solid',jacketColor:'navy',jacketPattern:'solid',trouserColor:'grey'};
const app=ROOT.querySelector('[data-ak-app]');
const HISTORY=[];
// 2026-09-24: a question shows no selection until it has been answered.
// state keeps its defaults (the engine needs a value), but a default is not an
// answer, and showing it as selected made every question look already answered.
const ANSWERED=new Set();
function isSel(key,val){return ANSWERED.has(key)&&state[key]===val;}
function go(screen,patch){
  // First navigation is the moment to start pulling live product data: the
  // answer is at least four choices away, so it has landed long before a card
  // needs it, and a visitor who never starts never pays for the request.
  liveProducts();
  if(state.screen!==screen)HISTORY.push(state.screen);
  Object.keys(patch||{}).forEach(function(k){ANSWERED.add(k);});
  Object.assign(state,patch||{},{screen:screen});
  render();
  // Put the answer's address in the bar so it can be copied or bookmarked
  // straight from the browser, not only from the button.
  try{
    if(screen==='answer'||screen==='tieAnswer')history.replaceState(null,'',withView(stateQuery()));
    else if(screen==='start')history.replaceState(null,'',basePath());
  }catch(e){}
}
function back(){
  const prev=HISTORY.pop();
  state.screen=prev||'start';
  render();
}
const patLabel={solid:'solid',stripe:'striped',check:'checked',dot:'dotted',motif:'motif'};
const colLabel={navy:'Navy',charcoal:'Charcoal',grey:'Grey',black:'Black',brown:'Brown',white:'White',lightblue:'Light blue',pink:'Pink'};

// Colours sampled from the woven cloth in each product photograph, then lifted
// so the flat chip reads as the tie looks in daylight rather than in the shadow
// between the threads. Do not eyeball these: re-sample if a tie is rephotographed.
// Every colour we make a tie in, so a man can tell the tool what he actually
// owns. Ordered dark to warm to pale rather than alphabetically: the screen is
// nineteen swatches and it should read as a considered sequence.
// Sampled from the cloth in each product photograph, then lifted so the flat
// chip reads as the tie looks in daylight. The three patterned-only colours
// (teal, red, tan) were set by eye, because sampling a foulard or a block
// stripe returns whichever element happens to dominate the crop.
const TIE_HEX={
  navy:'#2b3651',midnight:'#232838',black:'#1e1f21',grey:'#3a3c40',
  burgundy:'#8a2f3f',red:'#a8272d',
  purple:'#5c3573',lavender:'#cfb2d5',
  green:'#2a543b',olive:'#8e8755',teal:'#1c6b7a',
  brown:'#56463a',honey:'#a06a3e',tan:'#a8886a',orange:'#a8552a',
  champagne:'#c6a07a',gold:'#ded1a5',
  pink:'#b17b80',paleblue:'#c5d4dc'
};
const TIECOL={navy:'Navy',midnight:'Midnight blue',black:'Black',grey:'Charcoal',
  burgundy:'Burgundy',red:'Red',purple:'Purple',lavender:'Lavender',
  green:'Forest green',olive:'Olive',teal:'Teal',
  brown:'Brown',honey:'Honey brown',tan:'Tan',orange:'Burnt orange',
  champagne:'Champagne',gold:'Gold',pink:'Dusty rose',paleblue:'Pale blue'};

// ---------- screen furniture ----------
function cap1(s){return s?s.charAt(0).toUpperCase()+s.slice(1):s;}
function screen(kids){return el('div',{class:'ak-tp__screen'},kids);}
// The nav row carries the Back control and nothing else. The step counters and
// the "Where to start" eyebrow are gone: the three paths are branches, not
// steps, so numbering them implied a sequence the tool does not actually have.
// 2026-09-24: Back is the same "← Back" text link as on the answer bar (it was
// a grey filled chip here). A quiet "2 of 4" returns, but only INSIDE a path:
// the paths screen stays unnumbered because the three paths are branches, not
// steps. Each path's questions are a true sequence, and without a count there
// was no sense of how long the tool takes.
const FLOWS={
  suit:['suitColour','suitPattern','shirtColour','shirtPattern'],
  separates:['jacketColour','jacketPattern','trouser','shirtColour','shirtPattern'],
  tie:['tieColour','tiePattern']
};
function stepText(){
  const s=state.screen;
  const flow=/^tie/.test(s)?FLOWS.tie:(state.mode==='separates'?FLOWS.separates:FLOWS.suit);
  const i=flow.indexOf(s);
  return i<0?null:(i+1)+' of '+flow.length;
}
function wayrow(showBack){
  const kids=[];
  if(showBack)kids.push(el('button',{class:'ak-tp__barlink ak-tp__back',type:'button',onClick:back},'← Back'));
  const st=stepText();
  if(st)kids.push(el('span',{class:'ak-tp__step'},st));
  return el('div',{class:'ak-tp__wayrow'},kids);
}
// One stable id for the question on every screen, so the radio group can be
// labelled by it and focus can be moved to it when the screen changes.
const QID='ak-tp-question';
// A single polite live region, created once and reused, so the announcement is
// not itself torn down and rebuilt with the screen.
var LIVE=null;
if(app){
  LIVE=el('p',{class:'ak-tp__sr','aria-live':'polite','aria-atomic':'true'});
  app.parentNode.insertBefore(LIVE,app);
}
function question(text){return el('h2',{class:'ak-tp__q h1',id:QID,tabindex:'-1'},text);}

// ---------- 1. start ----------
// The H1 and the copy are rendered server-side in the section header, so the
// tool only owns the button. One heading on the page, and it is crawlable.
function screenStart(){
  return screen([
    el('button',{class:'button ak-tp__start',type:'button',onClick:()=>go('paths'),onPointerenter:()=>{const s=state.screen;state.screen='paths';preloadNext();state.screen=s;}},'Start')
  ]);
}

// ---------- 2. the three paths ----------
function screenPaths(){
  const PATHS=[
    ['I know my suit and shirt','Tell us what you are wearing and we will show you the tie that finishes it.',()=>go('suitColour',{mode:'suit'})],
    ['I am building a look from separates','An odd jacket and trousers. We anchor the base first, then choose the tie.',()=>go('jacketColour',{mode:'separates'})],
    ['I have a tie in mind','Already own one, or have your eye on it. See what to wear it with.',()=>go('tieColour')]
  ];
  const list=el('div',{class:'ak-tp__paths',role:'group'});
  PATHS.forEach(([h,p,fn])=>{
    list.appendChild(el('div',{class:'ak-tp__path',role:'button',tabindex:'0',onClick:fn,
      onKeydown:e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();fn();}}},[
      el('span',{},[el('span',{class:'ak-tp__path-h h3'},h),el('span',{class:'ak-tp__path-p'},p)])
    ]));
  });
  return screen([wayrow(true),question('What are you wearing?'),list]);
}

// ---------- 3. the suit path ----------
const SUIT_COLOURS=[['navy','Navy'],['charcoal','Charcoal'],['grey','Grey'],['black','Black'],['brown','Brown']];
const SUIT_PATTERNS=[['solid','Solid'],['stripe','Striped'],['check','Check']];

function screenSuitColour(){
  const items=SUIT_COLOURS.map(([k,l])=>plate(plateSrc('suit-'+k),l,isSel('suitColor',k),
    ()=>go('suitPattern',{suitColor:k}),l+' suit cloth'));
  return screen([wayrow(true),question('Which colour is the suit?'),plateGrid(5,items)]);
}
function screenSuitPattern(){
  const items=SUIT_PATTERNS.map(([k,l])=>plate(plateSrc('suitpat-'+state.suitColor+'-'+k)||plateSrc('suitpat-'+k),l,isSel('suitPattern',k),
    ()=>go('shirtColour',{suitPattern:k}),l+' suit cloth'));
  return screen([wayrow(true),question('Is the suit patterned?'),plateGrid(3,items)]);
}

// ---------- 4. the separates path ----------
const JACKET_COLOURS=[['navy','Navy'],['blue','Blue'],['charcoal','Charcoal'],['grey','Grey'],['tan','Tan'],['brown','Brown'],['olive','Olive']];
const JACKET_PATTERNS=[['solid','Solid'],['check','Check'],['stripe','Striped']];

function screenJacketColour(){
  const items=JACKET_COLOURS.map(([k,l])=>plate(plateSrc('jacket-'+k),l,isSel('jacketColor',k),
    ()=>go('jacketPattern',{jacketColor:k}),l+' jacket cloth'));
  return screen([wayrow(true),question('Which colour is the jacket?'),plateGrid(7,items)]);
}
function screenJacketPattern(){
  const items=JACKET_PATTERNS.map(([k,l])=>plate(plateSrc('jacketpat-'+state.jacketColor+'-'+k)||plateSrc('jacketpat-'+k),l,isSel('jacketPattern',k),
    ()=>go('trouser',{jacketPattern:k}),l+' jacket cloth'));
  return screen([wayrow(true),question('Is the jacket patterned?'),plateGrid(3,items)]);
}
// The trouser step is the one selector that is also advice, so the reasoning
// travels with the plate rather than being dropped for the sake of a bare grid.
function screenTrouser(){
  const recs=trouserRec(state.jacketColor);
  if(!recs.some(r=>r.id===state.trouserColor))state.trouserColor=recs[0].id;
  const items=recs.map(r=>plate(plateSrc('trouser-'+r.id),r.label,isSel('trouserColor',r.id),
    ()=>go('shirtColour',{trouserColor:r.id}),r.label+' trouser cloth',r.note));
  return screen([wayrow(true),question('Which trousers?'),plateGrid(3,items)]);
}

// ---------- 5. the shirt ----------
const SHIRT_COLOURS=[['white','White'],['lightblue','Light blue'],['pink','Pink']];
// Never photographed, so this one is a word list. A CSS approximation of a
// striped shirt is the swatch problem in another costume.
// The supporting line is not decoration. "Motif" and "dotted" are trade words,
// and a man who picks the wrong one gets the wrong advice, so each option says
// plainly what it looks like.
const SHIRT_PATTERNS=[
  ['solid','Solid','One colour, no pattern at all.'],
  ['stripe','Striped','Any stripe, from a fine bengal to a bold butcher stripe.'],
  ['check','Checked','Gingham, tattersall, windowpane, or a graph check.'],
  ['dot','Dotted','A repeating dot or pin spot.'],
  ['motif','Motif','A small repeating figure: paisley, a medallion, a print.']
];

function screenShirtColour(){
  const sep=state.mode==='separates';
  const items=SHIRT_COLOURS.map(([k,l])=>plate(plateSrc('shirt-'+k),l,isSel('shirtColor',k),
    ()=>go('shirtPattern',{shirtColor:k}),l+' shirt collar'));
  return screen([wayrow(true),question('Which colour is the shirt?'),plateGrid(3,items)]);
}
function screenShirtPattern(){
  const sep=state.mode==='separates';
  const items=SHIRT_PATTERNS.map(([k,l,note])=>({label:l,note:note,sel:isSel('shirtPattern',k),pick:()=>go('answer',{shirtPattern:k})}));
  return screen([wayrow(true),question('Is the shirt patterned?'),wordList(items)]);
}

// ---------- 6. the answer ----------
// The chrome for an answer: Back and the selection on the left, the two things
// you can do with the answer on the right. One bar, so the page below it is
// nothing but the answer.
function answerBar(summary){
  return el('div',{class:'ak-tp__bar'},[
    el('div',{class:'ak-tp__barleft'},[
      el('button',{class:'ak-tp__barlink',type:'button',onClick:back},'← Back'),
      startAgainLink()
    ]),
    el('div',{class:'ak-tp__barright'},[
      el('p',{class:'ak-tp__inputs'},summary),
      shareLink()
    ])
  ]);
}

function screenAnswer(){
  const sep=state.mode==='separates';
  const suitColor=sep?JACKETS[state.jacketColor].key:state.suitColor;
  const suitPattern=sep?state.jacketPattern:state.suitPattern;
  const g=guidance({suitColor,suitPattern,shirtColor:state.shirtColor,shirtPattern:state.shirtPattern,jacket:sep?state.jacketColor:null});

  const inputs=sep
    ?`${JLABEL[state.jacketColor]} ${patLabel[state.jacketPattern]} jacket · ${TLABEL[state.trouserColor]} trousers · ${colLabel[state.shirtColor]} ${patLabel[state.shirtPattern]} shirt`
    :`${colLabel[state.suitColor]} ${patLabel[state.suitPattern]} suit · ${colLabel[state.shirtColor]} ${patLabel[state.shirtPattern]} shirt`;

  let cap=g.cap,key=g.key;
  if(sep){
    const shoe=SHOE[suitColor]||'brown';
    cap=`Full look. ${JLABEL[state.jacketColor]} ${state.jacketPattern} jacket over ${TLABEL[state.trouserColor]} trousers, ${state.shirtColor} ${state.shirtPattern} shirt, finished with a ${COLLABEL[g.colours[0]]} solid grenadine tie. ${shoe} shoes. Separates that come together as one considered outfit.`;
    key=`${state.jacketColor}-${state.jacketPattern}-jkt_${state.trouserColor}-trs_${state.shirtColor}-${state.shirtPattern}_${g.colours[0]}-solid`;
  }

  const colour=COLLABEL[g.colours[0]];
  const weave=g.primary?g.primary.weave.toLowerCase():'grenadine';

  const shot=look(cap,key,sep
    ?{sep:true,upper:state.jacketColor,upperPat:state.jacketPattern,trouser:state.trouserColor,shirt:state.shirtColor,shirtPat:state.shirtPattern,tie:g.colours[0]}
    :{sep:false,upper:state.suitColor,upperPat:state.suitPattern,shirt:state.shirtColor,shirtPat:state.shirtPattern,tie:g.colours[0]});
  shot.classList.add('ak-tp__shot');

  // The recommendation is the headline. H2, not H1: the page already has one in
  // the section header, and one per page is the rule.
  const lead=el('div',{class:'ak-tp__lead'},[
    el('h2',{class:'ak-tp__rec-h',id:QID,tabindex:'-1'},`Wear ${article(colour)} ${colour} ${weave} tie.`)
    // 2026-09-24: the "Colour · Weave · Como silk" spec line was removed per
    // founder markup. It repeated the headline.
  ]);

  // The argument is folded. It is available to anyone who wants it and imposed
  // on no one, which is what lets the recommendation, the tie and the buy sit
  // together without two paragraphs pushing them apart.
  // 2026-09-24: the verdict alone ("Three patterns: tread carefully.") was
  // cryptic. Its first sentence now sits under it; the rest stays folded.
  const body=String(g.rule.body||'');
  const m=body.match(/^.*?[.!?](\s|$)/);
  const firstLine=m?m[0].trim():body;
  const rest=body.slice(m?m[0].length:body.length).trim();
  const reasons=[];
  if(rest)reasons.push(el('p',{class:'ak-tp__reason'},rest));
  const gcopy=sep?answerCopy(g.colours[0],state.jacketColor,false):answerCopy(g.colours[0],state.suitColor,true);
  if(gcopy)reasons.push(el('p',{class:'ak-tp__reason'},gcopy));
  const panel=el('div',{class:'ak-tp__whypanel',id:'ak-tp-why',hidden:'hidden'},reasons);
  const toggle=el('button',{class:'ak-tp__whylink',type:'button','aria-expanded':'false','aria-controls':'ak-tp-why'},'Why this works');
  toggle.addEventListener('click',function(){
    const open=toggle.getAttribute('aria-expanded')==='true';
    toggle.setAttribute('aria-expanded',String(!open));
    toggle.textContent=open?'Why this works':'Hide the reasoning';
    panel.hidden=open;
  });
  const why=el('div',{class:'ak-tp__why'},[
    el('h3',{class:'ak-tp__verdict'},g.rule.title),
    firstLine?el('p',{class:'ak-tp__reason ak-tp__reason--lead'},firstLine):null,
    reasons.length?toggle:null,reasons.length?panel:null]);

  const col=[lead,why,buyBlock(g.primary)];

  // Alternates as rows, not tiles. Tiles gave them parity with the
  // recommendation; this is still one answer with two ways round it.
  const alts=[];
  if(g.altPattern){
    alts.push({p:g.altPattern,note:g.anySuitPat
      ? 'More expressive, and it works here only because its scale is clearly different from the suit.'
      : 'The same idea, more expressive. It works because it is the only pattern in the outfit.'});
  }
  if(g.altColour){
    alts.push({p:g.altColour,note:(!sep&&ALT_NOTE[suitColor+'|'+g.altColour.colour])||'The same idea in a second colour, a shade less expected.'});
  }
  if(alts.length){
    const rows=el('div',{class:'ak-tp__alts'});
    alts.forEach(a=>rows.appendChild(altRow(a.p,a.note)));
    col.push(el('div',{class:'ak-tp__altsblock'},[
      el('h4',{class:'ak-tp__alts-label'},"If you'd rather"),rows]));
  }
  if(!sep&&suitColor==='black'&&state.shirtColor==='white'&&state.shirtPattern==='solid'){
    col.push(el('div',{class:'ak-tp__altsblock'},[
      el('h4',{class:'ak-tp__alts-label'},'For the evening'),
      el('div',{class:'ak-tp__alts'},altRow(EVENING_BOW,EVENING_NOTE))]));
  }

  return screen([
    answerBar(inputs),
    el('div',{class:'ak-tp__answer'},[shot,el('div',{class:'ak-tp__colr'},col)]),
    feedback(inputs)
  ]);
}

// One alternate, as a row: small packshot, name and price on one line, the one
// sentence that says what choosing it changes.
function altRow(p,note){
  return el('a',{class:'ak-tp__alt',href:p.url},[
    el('span',{class:'ak-tp__pack ak-tp__pack--sm'},
      el('img',{src:p.img,alt:p.title,loading:'lazy',decoding:'async'})),
    el('span',{class:'ak-tp__altbody'},[
      el('span',{class:'ak-tp__altline'},[
        el('span',{class:'ak-tp__altname'},p.title),
        el('span',{class:'ak-tp__altprice'},p.price)
      ]),
      el('span',{class:'ak-tp__altwhy'},note),
      (p.marker==='Vault'||p.marker==='Seasonal')?el('span',{class:'ak-tp__card-m'},p.marker):null
    ])
  ]);
}

// ---------- 7. the tie path ----------
const TIE_PATTERNS=[
  ['solid','Solid','One colour. The weave is the only texture.'],
  ['stripe','Striped','A repp or block stripe running across the blade.'],
  ['dot','Dotted','A repeating dot or pin spot.'],
  ['motif','Motif','A small repeating figure: foulard, medallion, floral.']
];

function screenTieColour(){
  const items=Object.keys(TIE_HEX).map(k=>colourPlate(TIE_HEX[k],TIECOL[k],isSel('tieColor',k),()=>go('tiePattern',{tieColor:k})));
  // Flat colour, not cloth, so these can run smaller and tighter than the garment
  // plates. The 150px floor on those exists because a photograph of cloth needs
  // size to read; a colour does not.
  const g=plateGrid(19,items);
  g.classList.add('ak-tp__plates--colour');
  return screen([wayrow(true),question('Which colour is the tie?'),g]);
}
function screenTiePattern(){
  const items=TIE_PATTERNS.map(([k,l,note])=>({label:l,note:note,sel:isSel('tiePattern',k),pick:()=>go('tieAnswer',{tiePattern:k})}));
  return screen([wayrow(true),question('Is the tie patterned?'),wordList(items)]);
}
function screenTieAnswer(){
  const tie={color:state.tieColor,pattern:state.tiePattern,
    title:`${TIECOL[state.tieColor]} ${state.tiePattern==='solid'?'solid':patLabel[state.tiePattern]} tie`};
  const combos=combosFor(tie);

  // The photographs only cover the eleven tie colours we shot. The picker now
  // offers nineteen, so a colour can be a perfectly good answer with nothing
  // photographed behind it. Where that happens the pairings are set as a list
  // rather than a grid of empty frames: no photograph is better than a blank
  // one, and substituting a different colour here would be substituting the
  // very thing the visitor came to ask about.
  const shot=combos.map(c=>({c,src:resolveLook(
    {sep:false,upper:c.suit,upperPat:'solid',shirt:c.shirt,shirtPat:'solid',tie:tie.color,tiePat:tie.pattern}).src}));
  const anyPhoto=shot.some(x=>x.src);

  let grid;
  if(anyPhoto){
    grid=el('div',{class:'ak-tp__combos'});
    shot.forEach(({c})=>{
      const key=`${c.suit}-solid_${c.shirt}-solid_${tie.color}-solid`;
      const pt={sep:false,upper:c.suit,upperPat:'solid',shirt:c.shirt,shirtPat:'solid',tie:tie.color,tiePat:tie.pattern};
      const cell=look(c.cap,key,pt);
      cell.appendChild(el('h3',{class:'ak-tp__combo-h'},`${c.suitLabel}, ${c.shirtLabel.toLowerCase()}`));
      cell.appendChild(el('p',{class:'ak-tp__combo-p'},c.note));
      grid.appendChild(cell);
    });
    // 2026-09-24: when all three pairings substitute the same thing (e.g. a solid
    // tie standing in for a striped one), the same caption appeared three times.
    // Keep it once, on the first photograph.
    const seen=new Set();
    grid.querySelectorAll('.ak-tp__heronote').forEach(n=>{
      if(seen.has(n.textContent))n.remove();else seen.add(n.textContent);
    });
  }else{
    grid=el('div',{class:'ak-tp__words ak-tp__words--combos'});
    shot.forEach(({c})=>{
      grid.appendChild(el('div',{class:'ak-tp__word ak-tp__word--static'},[
        el('span',{},[el('h3',{class:'ak-tp__word-h h3'},`${c.suitLabel}, ${c.shirtLabel.toLowerCase()}`),
                      el('span',{class:'ak-tp__word-p'},c.note)])
      ]));
    });
  }

  let intro=tie.pattern==='solid'
    ?'A solid tie is the most versatile piece you can own. These are the pairings that make it effortless.'
    :'A patterned tie asks a little more of the rest of the outfit. These are the pairings where it shines.';
  // A colour that clears the bar against no suit is not a failure of the tool.
  // It is a tie for an odd jacket, and saying so is more useful than three
  // pairings we do not believe in.
  if(!combos.length){
    intro='This is a colour for separates rather than a business suit. Against navy, charcoal, grey, black or brown it '
         +'competes instead of settling, so wear it with an odd jacket, where it has room to be the focal point.';
  }

  const head=[el('h2',{class:'ak-tp__verdict ak-tp__verdict--tie h2'},tie.title+'.'),el('p',{class:'ak-tp__reason'},intro)];
  // The pattern advice belongs here, said once, rather than repeated under every
  // pairing where it was identical three times over.
  if(combos.length)head.push(el('p',{class:'ak-tp__reason'},PATTERN_ADVICE[tie.pattern]||PATTERN_ADVICE.solid));
  const tieGuidance=blockCopy(tie.color);
  if(tieGuidance)head.push(el('p',{class:'ak-tp__reason'},tieGuidance));

  // Exact colour and pattern first. Failing that, offer what we do make in that
  // colour rather than nothing: a man who owns a navy dotted tie is still well
  // served by seeing the navy grenadine.
  const exact=productBy(tie.color,tie.pattern);
  const near=exact?null:productsIn(tie.color).sort((a,b)=>(a.pattern==='solid'?-1:1)-(b.pattern==='solid'?-1:1))[0];
  const rec=[];
  if(exact)rec.push(buyBlock(exact));
  else if(near){
    // A caveat, not a heading: it must not inherit the alternates heading style.
    rec.push(el('p',{class:'ak-tp__spec'},'We do not make that exact tie. This is the closest one we do.'));
    rec.push(buyBlock(near));
  }else rec.push(el('p',{class:'ak-tp__spec'},'We do not make a tie in this colour. The pairings above still hold.'));

  // The tie path is the same kind of screen, so it takes the same bar. Its
  // photographs are three pairings rather than one look, so it keeps the
  // single-column flow underneath rather than the two-column answer layout.
  return screen([
    answerBar(tie.title),
    el('div',{class:'ak-tp__col'},head),
    grid,
    el('div',{class:'ak-tp__rec'},rec),
    feedback(tie.title)
  ]);
}

// ---------- answer feedback (2026-09-27) ----------
// One quiet line under every answer: "Did this answer help? Yes · No".
// A No opens an optional note asking what they expected. Each response is
// sent to Klaviyo as a "Tie Tool Feedback" event carrying the exact answer
// link, so a No can be opened and seen as the visitor saw it. No email is
// asked for and nothing expects a reply. Anonymous visitors are keyed by a
// random id kept in this browser.
const FB_METRIC='Tie Tool Feedback';
const FB_DONE={};   // answer link -> 'yes' | 'no' | 'sent', for this page view
function fbVisitorId(){
  let id=null;
  try{id=localStorage.getItem('ak_tp_fb_id');}catch(e){}
  if(!id){
    id='tp-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);
    try{localStorage.setItem('ak_tp_fb_id',id);}catch(e){}
  }
  return id;
}
function fbSend(props){
  const company=ROOT.getAttribute('data-kl-company');
  if(!company)return;
  try{
    fetch('https://a.klaviyo.com/client/events/?company_id='+encodeURIComponent(company),{
      method:'POST',
      headers:{'Content-Type':'application/json','revision':'2025-10-15'},
      body:JSON.stringify({data:{type:'event',attributes:{
        properties:props,
        metric:{data:{type:'metric',attributes:{name:FB_METRIC}}},
        profile:{data:{type:'profile',attributes:{anonymous_id:fbVisitorId()}}}
      }}})
    }).then(function(r){
      if(r.status!==202&&window.console)console.warn('[ak-tie-pairing] feedback: Klaviyo returned '+r.status);
    }).catch(function(){});
  }catch(e){}
}
function feedback(answerLabel){
  const link=shareUrl();
  const base={helpful:null,answer:answerLabel||'',link:link,path:state.screen==='tieAnswer'?'tie':state.mode};
  const wrap=el('div',{class:'ak-tp__fb'});
  function thanks(msg){wrap.innerHTML='';wrap.appendChild(el('p',{class:'ak-tp__fb-q',role:'status'},msg));}
  function askNote(){
    wrap.innerHTML='';
    const input=el('textarea',{class:'ak-tp__fb-input',rows:'2',maxlength:'500',
      'aria-label':'What did you expect to see?',placeholder:'What did you expect to see? (optional)'});
    const send=el('button',{class:'ak-tp__fb-send',type:'button',onClick:function(){
      const note=(input.value||'').trim();
      if(note)fbSend(Object.assign({},base,{helpful:false,stage:'note',note:note}));
      FB_DONE[link]='sent';
      thanks('Thank you. It helps us make the tool better.');
    }},'Send');
    wrap.appendChild(el('p',{class:'ak-tp__fb-q'},'Sorry it missed. What were you hoping to see?'));
    wrap.appendChild(input);
    wrap.appendChild(send);
    setTimeout(function(){try{input.focus({preventScroll:true});}catch(e){}},0);
  }
  if(FB_DONE[link]==='yes'||FB_DONE[link]==='sent'){thanks('Thank you.');return wrap;}
  if(FB_DONE[link]==='no'){askNote();return wrap;}
  const yes=el('button',{class:'ak-tp__fb-btn',type:'button',onClick:function(){
    fbSend(Object.assign({},base,{helpful:true,stage:'vote'}));
    FB_DONE[link]='yes';thanks('Thank you.');
  }},'Yes');
  const no=el('button',{class:'ak-tp__fb-btn',type:'button',onClick:function(){
    // The vote is sent now, so a No counts even if the note is never written.
    fbSend(Object.assign({},base,{helpful:false,stage:'vote'}));
    FB_DONE[link]='no';askNote();
  }},'No');
  wrap.appendChild(el('p',{class:'ak-tp__fb-q'},['Did this answer help? ',yes,el('span',{class:'ak-tp__fb-sep','aria-hidden':'true'},' · '),no]));
  return wrap;
}

// ---------- render ----------
const SCREENS={
  start:screenStart,paths:screenPaths,
  suitColour:screenSuitColour,suitPattern:screenSuitPattern,
  jacketColour:screenJacketColour,jacketPattern:screenJacketPattern,trouser:screenTrouser,
  shirtColour:screenShirtColour,shirtPattern:screenShirtPattern,
  answer:screenAnswer,
  tieColour:screenTieColour,tiePattern:screenTiePattern,tieAnswer:screenTieAnswer
};
// ---------- live product data ----------
// Classification (colour, pattern, weave, marker) is editorial judgement and stays
// in the manifest. Everything a customer actually looks at on a card - the
// photograph, the price, the title - is read from Shopify at runtime. That is the
// only way the tool cannot drift: it can never show a tie on a background the store
// does not use, at a stale price, or cropped to a shape the photography is not.
// Fetched once per session, lazily on first interaction so a visitor who never
// presses Start never pays for it, and it fails silently back to the manifest.
var LIVEMAP=null, LIVE_TRIED=false;
function money(v){
  var n=parseFloat(v);
  if(isNaN(n))return null;
  return '$'+(n%1===0?n.toFixed(0):n.toFixed(2));
}
function handleOf(u){return String(u||'').split('?')[0].replace(/\/$/,'').split('/').pop();}
function applyLive(map){
  if(!map)return;
  LIVEMAP=map;
  PRODUCTS.forEach(function(p){
    var s=map[handleOf(p.url)];
    if(!s)return;
    if(s.img)p.img=s.img;
    if(s.price)p.price=s.price;
    if(s.title)p.title=s.title;
    if(s.variants)p.variants=s.variants;
  });
  // If an answer is already on screen it was drawn without stock data, so the
  // buy block is showing nothing rather than the wrong thing. Redraw it now the
  // truth is in - quietly, so it does not steal focus or scroll the page.
  if(app&&(state.screen==='answer'||state.screen==='tieAnswer'))render(true);
}
function liveProducts(){
  if(LIVE_TRIED)return;
  LIVE_TRIED=true;
  try{
    var c=JSON.parse(sessionStorage.getItem('ak-tp-live')||'null');
    if(c){applyLive(c);return;}
  }catch(e){}
  fetch('/products.json?limit=250',{credentials:'omit'})
    .then(function(r){return r.ok?r.json():null;})
    .then(function(d){
      if(!d||!d.products)return;
      var map={};
      d.products.forEach(function(p){
        if(p.product_type!=='Tie')return;
        var v=p.variants&&p.variants[0];
        map[p.handle]={
          img:p.images&&p.images[0]?p.images[0].src:null,
          title:p.title,
          price:v?money(v.price):null,
          // Length is a real choice: 33 of the 44 ties come Standard and Extra
          // Long. And most of the line is out of stock at any moment, so the
          // card has to be able to say so rather than offer a dead button.
          variants:(p.variants||[]).map(function(x){
            return {id:x.id,title:x.option1||x.title||'Standard',available:!!x.available};
          })
        };
      });
      try{sessionStorage.setItem('ak-tp-live',JSON.stringify(map));}catch(e){}
      applyLive(map);
    })
    .catch(function(){});
}

function render(quiet){
  if(!app)return;
  const first=quiet||!app.firstChild;
  bisPark();
  app.innerHTML='';
  const fn=SCREENS[state.screen]||screenStart;
  app.appendChild(fn());
  ROOT.classList.toggle('is-started',state.screen!=='start');
  ROOT.dataset.screen=state.screen;
  preloadNext();
  // A quiet repaint is the same screen redrawn with better data, not a
  // navigation: it must not scroll the page out from under whoever is reading.
  if(state.screen!=='start'&&!quiet){
    const y=ROOT.getBoundingClientRect().top+window.pageYOffset-24;
    // Honour the system setting. A smooth scroll on every screen change is the
    // kind of motion that makes some people ill.
    const calm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top:Math.max(0,y),behavior:calm?'auto':'smooth'});
  }
  // Replacing the screen's contents is silent to a screen reader: the visitor
  // chooses a colour and hears nothing back. Move focus to the new question so
  // it is read out, and mirror it into a polite live region for the answer
  // screens, which have a verdict rather than a question. Never on first paint,
  // or the page would steal focus before anyone has asked it to.
  if(!first){
    const q=app.querySelector('#'+QID)||app.querySelector('.ak-tp__verdict');
    if(q){
      if(!q.hasAttribute('tabindex'))q.setAttribute('tabindex','-1');
      try{q.focus({preventScroll:true});}catch(e){q.focus();}
      if(LIVE)LIVE.textContent=q.textContent;
    }
  }
}
// ---------- boot ----------
// Two small JSON manifests: the full-look photographs and the selector plates.
// Both live as theme assets and point at Shopify Files, so the section ships
// two fetches and no inline payload. The tool renders either way; a missing
// plate degrades to its caption rather than to an empty grid.
  var tag=document.currentScript||document.querySelector('script[data-looks]');
  var srcLooks=tag&&tag.dataset?tag.dataset.looks:null;
  var srcPlates=tag&&tag.dataset?tag.dataset.plates:null;
  var srcProducts=tag&&tag.dataset?tag.dataset.products:null;

  function grab(url){
    if(!url)return Promise.resolve(null);
    return fetch(url,{credentials:'omit'}).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
  }
  function boot(){
    var st=ROOT.querySelector('[data-ak-static]'); if(st)st.hidden=true;
    render();
  }
  Promise.all([grab(srcLooks),grab(srcPlates),grab(srcProducts)]).then(function(res){
    if(res[0]){LOOKMAP=res[0];LOOKS=new Set(Object.keys(LOOKMAP));}
    if(res[1]){PLATES=res[1];}
    if(res[2]&&res[2].length){PRODUCTS=normaliseProducts(res[2]);}
  }).then(function(){
    // An answer has its own address, so a shared or bookmarked link has to land
    // on that answer rather than on the start screen. Restoring before the first
    // render means the visitor never sees the tool rewind itself.
    if(restoreFromQuery())liveProducts();
    boot();
  });
})();
